<template>
  <div :class="$s.SectionContent">
    <o-heading
      v-if="column.title"
      :class="$s.Title"
      size="title-1"
      element="h2"
      v-html="column.title"
    />
    <o-heading
      v-if="column.subtitle"
      :class="$s.Subtitle"
      size="title-3"
      v-html="column.subtitle"
    />
    <div
      v-if="column.content"
      :class="$s.Html"
      v-html="column.content"
    />
  </div>
</template>

<script>
import { OHeading } from 'orbit-ui/components/Heading';

const SectionContent = {
  name: 'FeatureSectionContent',

  components: {
    OHeading,
  },

  props: {
    column: {
      type: Object,
      default: () => ([{}]),
    },
  },
};

export default SectionContent;
</script>

<style module="$s" lang="scss">
.SectionContent {
  color: var(--color-gray-60);
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  letter-spacing: 0;
  line-height: 32px;
}

.Title {
  margin-bottom: var(--space-x3);
}

.Subtitle {
  font-weight: bold;
}

.Html a {
  color: var(--brand-color-dark);
  text-decoration: none;
}
</style>
